import { useState } from "react";
import { Column } from "../../../../../core/components/Column";
import { TextComponent } from "../../../../../core/components/TextComponent";
import { CustomButton } from "../../../../../core/components/CustomButton";
import { ImageUploader } from "../../../../../core/components/ImageUploader";
import { Container } from "../../../../../core/components/Container";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../../../../core/store/store";
import { setUserInfo } from "../../store/OnboardingSlice";

const isSameFile = (left?: File | null, right?: File | null) => {
    if (!left || !right) {
        return false;
    }

    return (
        left.name === right.name &&
        left.size === right.size &&
        left.type === right.type &&
        left.lastModified === right.lastModified
    );
};

export function AddImage() {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const filesFromRedux = useSelector((state: RootState) => state.onboarding.userInfo?.files) || [];
    const existingApprovalToken = useSelector(
        (state: RootState) => state.onboarding.userInfo?.signup_photo_liveness_token
    );
    const [files, setFiles] = useState<File[]>(filesFromRedux);

    const handleOnClick = async () => {
        if (files) {
            const firstSavedFile = filesFromRedux[0] || null;
            const currentFirstFile = files[0] || null;
            const firstPhotoChanged =
                (firstSavedFile == null) !== (currentFirstFile == null) ||
                !isSameFile(firstSavedFile, currentFirstFile);

            dispatch(
                setUserInfo({
                    files: files,
                    signup_photo_liveness_token: firstPhotoChanged
                        ? undefined
                        : existingApprovalToken,
                })
            );
        }
        navigate("/description");
    };

    return (
        <Column
            crossAxisAlignment="center"
            className="md:bg-white px-10 pb-10 md:my-10 md:p-20 self-center text-center w-full md:w-[584px] lg:shadow-xl rounded-lg gap-10"
        >
            <ImageUploader
                className="w-full"
                files={files}
                setFiles={(newFiles: File[] | null) => setFiles(newFiles || [])}
                inputId="fileInput"
                columns={3}
                slots={9}
                multiple={true}
                cropToSquareOnUpload
            />
            <Container>
                <TextComponent variant="h2" className="font-bold">
                    Add more images
                </TextComponent>
                <TextComponent variant="h6" className="text-[#6B6B6B] mt-2 md:w-[390px]">
                    Would you like to add more images of yourself? The more images you show other members the greater your changes are of matching with them
                </TextComponent>
            </Container>
            <CustomButton onClick={handleOnClick}>
                Continue
            </CustomButton>
        </Column>
    );
}
